import { useQuery } from '@tanstack/react-query'
import { TOURNAMENT_QUERY_KEYS } from '@/modules/tournament/constants'
import { TournamentService } from '@/modules/tournament/api/services'
import type { paths } from '@/schema'

type TournamentPlayersQuery =
	paths['/api/admin/tournaments/{id}/players']['get']['parameters']['query']
type TournamentPlayersResponse =
	paths['/api/admin/tournaments/{id}/players']['get']['responses']['200']['content']['application/json']

const useQueryGetTournamentPlayers = (
	id: string,
	query?: TournamentPlayersQuery,
) => {
	return useQuery<TournamentPlayersResponse>({
		queryKey: TOURNAMENT_QUERY_KEYS.TOURNAMENTS.PLAYERS(id, query),
		queryFn: () => TournamentService.getTournamentPlayers(id, query),
		enabled: !!id,
	})
}

export default useQueryGetTournamentPlayers
